import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { validateUserURL } from "../utils/constants/apiEndPoints";
import privateAxios from "../utils/axiosPrivate";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    authUser: null,
    authUserloading: false,
    isAfterValidated: false
  },
  reducers: {
    setAuthUser: (state, action) => {
      state.authUser = action.payload;
    },
    setAuthUserLoading: (state, action) => {
      state.authUserloading = action.payload;
    },
    setIsAfterValidated: (state, action) => {
      state.isAfterValidated = action.payload;
    }
  }
});

export const validateUser = createAsyncThunk(
  "auth/validateUser",
  async (_, { dispatch }) => {
    try {
      dispatch(setAuthUserLoading(true));
      const response = await privateAxios.post(validateUserURL);
      const isAuthenticated = response?.data?.message === "valid user";
      dispatch(setAuthUser(isAuthenticated === true));
      dispatch(setAuthUserLoading(false));
      dispatch(setIsAfterValidated(true));
      return response;
    } catch {
      dispatch(setAuthUserLoading(false));
      dispatch(setAuthUser(false));
      dispatch(setIsAfterValidated(true));
      localStorage.removeItem("isAuthenticated");
    }
  }
);
export const { setAuthUser, setAuthUserLoading, setIsAfterValidated } =
  authSlice.actions;
export default authSlice.reducer;
